/**
 * Maps order_record_status values from the API to human-readable labels
 * and display variants for badges/tags.
 */

export type OrderStatusVariant = 'draft' | 'submitted' | 'confirmed' | 'shipped' | 'completed' | 'failed' | 'cancelled' | 'detected';

interface OrderStatusDisplay {
  /** Short label for the inline tag in the email list. */
  tagLabel: string;
  /** Title shown in the expanded OrderDetectedBadge. */
  badgeTitle: string;
  /** Visual variant controlling colors. */
  variant: OrderStatusVariant;
}

const STATUS_MAP: Record<string, OrderStatusDisplay> = {
  draft: {
    tagLabel: 'Order Draft',
    badgeTitle: 'Order Draft',
    variant: 'draft',
  },
  submission_failed: {
    tagLabel: 'Submission Failed',
    badgeTitle: 'Submission Failed',
    variant: 'failed',
  },
  submitted_to_sage: {
    tagLabel: 'Order Submitted',
    badgeTitle: 'Order Submitted',
    variant: 'submitted',
  },
  confirmed_in_sage: {
    tagLabel: 'Order Confirmed',
    badgeTitle: 'Order Confirmed',
    variant: 'confirmed',
  },
  accepted: {
    tagLabel: 'Order Accepted',
    badgeTitle: 'Order Accepted',
    variant: 'confirmed',
  },
  shipped: {
    tagLabel: 'Order Shipped',
    badgeTitle: 'Order Shipped',
    variant: 'shipped',
  },
  order_completed: {
    tagLabel: 'Order Completed',
    badgeTitle: 'Order Completed',
    variant: 'completed',
  },
  cancelled: {
    tagLabel: 'Order Cancelled',
    badgeTitle: 'Order Cancelled',
    variant: 'cancelled',
  },
};

const DEFAULT_DISPLAY: OrderStatusDisplay = {
  tagLabel: 'Order Detected',
  badgeTitle: 'Order Detected',
  variant: 'detected',
};

/**
 * Resolve the display info for an order based on its record status.
 * Falls back to "Order Detected" when no order record exists yet.
 */
export function getOrderStatusDisplay(
  orderRecordStatus: string | null | undefined,
): OrderStatusDisplay {
  if (!orderRecordStatus) return DEFAULT_DISPLAY;
  return STATUS_MAP[orderRecordStatus] ?? DEFAULT_DISPLAY;
}
